<template>
  <v-container class="ma-0 pa-0">
    <img class="elevation"
         srcset="../assets/ele-600w.jpg 600w,
                 ../assets/ele-900w.jpg 900w,
                 ../assets/ele-1200w.jpg 1200w,
                 ../assets/ele-1600w.jpg 1600w"
         src="../assets/ele-600w.jpg"
    >
  </v-container>
</template>

<style scoped>
  .elevation {
    width: 100%;
  }

  @media screen and (min-width: 961px) { /* medium+ screens */
    .elevation {
      height: 100vh;
      object-fit: cover;
    }
  }
</style>

<script>
export default {
  name: 'MainBanner',

  data: () => ({
  }),
};
</script>
